import React from 'react';
import { QuoteIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { StaggerTitle } from './ui/StaggerTitle';
import { CountUp } from './ui/CountUp';
import { ConsultButton } from './ui/Buttons';
import { WhatsAppChat } from './WhatsAppChat';
import { useInViewOnce } from '../hooks/useInViewOnce';
import { chatThreads } from '../data/chats';
const [threadFrances, threadMaria] = chatThreads;
/** #t=0.001 makes browsers render the real first frame as the preview */
const VIDEO_SRC = 'https://cdn.magicpatterns.com/uploads/hJ4KKuMSsXU9CffjptDD2D/video%201%20corto.mp4#t=0.001';
interface CardProps {
  children: React.ReactNode;
  delay: number;
  featured?: boolean;
}
function TestimonialCard({
  children,
  delay,
  featured = false
}: CardProps) {
  const {
    ref,
    inView
  } = useInViewOnce<HTMLElement>(0.25);
  return <article ref={ref} style={delay ? {
    transitionDelay: `${delay}s`
  } : undefined} className={`card-reveal ${inView ? 'is-visible' : ''} relative overflow-hidden rounded-2xl bg-white ring-1 ring-black/10 hover:shadow-float ${featured ? 'shadow-[0_24px_60px_-24px_rgba(0,0,0,0.45)]' : 'shadow-sm'}`} data-id="element-104" data-mp="v8wtc9wl3kcp">
      {children}
    </article>;
}
function VideoTestimonial() {
  return <video src={VIDEO_SRC} preload="metadata" playsInline controls width={720} height={1280} className="aspect-[9/16] w-full bg-black object-contain" aria-label="Testimonio en video de una consultante" data-id="element-105" data-mp="7a4uyrz8zdk9" />;
}
export function Testimonials() {
  return <section id="testimonios" className="bg-[#f5f5f4] px-5 py-14 sm:px-8 sm:py-20" data-id="element-106" data-mp="q6ml54yg75ee">
      <div className="mx-auto max-w-6xl" data-id="element-107" data-mp="q4sb4lopsxp3">
        <Reveal data-id="element-108" data-mp="v4xuzfoqtfwm">
          <p className="text-center font-sans text-xs font-semibold tracking-[0.3em] text-brand-red" data-id="element-109" data-mp="v4enyu0msbxd">
            HISTORIAS REALES
          </p>
        </Reveal>
        <StaggerTitle text="Testimonios" className="mt-3 text-center font-serif text-5xl font-bold text-brand-ink sm:text-6xl" data-id="element-110" data-mp="1nlqsf9132opx" />

        <div className="mt-14 grid grid-cols-1 items-start gap-6 md:grid-cols-3" data-id="element-111" data-mp="1xh7nkt8v46q0">
          <TestimonialCard delay={0} data-id="element-112" data-mp="1sjfmp9q8pa9o">
            <WhatsAppChat thread={threadFrances} data-id="element-113" data-mp="1ohavehn9kpq7" />
          </TestimonialCard>

          <TestimonialCard delay={0.08} featured data-id="element-114" data-mp="1ojf9fsevn547">
            <VideoTestimonial data-id="element-115" data-mp="1jj10871jhp4l" />
          </TestimonialCard>

          <TestimonialCard delay={0.16} data-id="element-116" data-mp="1jkkfbubglu4s">
            <WhatsAppChat thread={threadMaria} data-id="element-117" data-mp="1ejejvoqezsrk" />
          </TestimonialCard>
        </div>

        <div className="mt-20 border-t border-black/10 pt-14 text-center" data-id="element-118" data-mp="19rwkh541i08p">
          <Reveal data-id="element-119" data-mp="14tbl17wm3klb">
            <p className="font-display text-[14vw] leading-[0.85] text-brand-red sm:text-7xl lg:text-8xl" data-id="element-120" data-mp="14strwk58xmhm">
              MÁS DE <CountUp to={21} data-id="element-121" data-mp="10srni384meyn" /> AÑOS DE EXPERIENCIA
            </p>
          </Reveal>
          <Reveal delay={0.08} data-id="element-122" data-mp="vt6qvzgfiip3">
            <p className="mt-5 font-serif text-xl italic text-brand-ink/70 sm:text-2xl" data-id="element-123" data-mp="vs3yto7dea7l">
              Experiencia, seguridad y discreción
            </p>
          </Reveal>
          <Reveal delay={0.14} data-id="element-124" data-mp="32hp48xes83ll">
            <div className="mt-10 flex flex-col items-center gap-5" data-id="element-125" data-mp="32gnt6sxrnh3v">
              <h3 className="max-w-xl font-sans text-xl font-semibold leading-snug text-brand-ink sm:text-2xl" data-id="element-126" data-mp="37exor4nekjq0">
                Contáctanos para recibir orientación espiritual
              </h3>
              <ConsultButton label="Consulta" className="w-full max-w-xs sm:w-auto" data-id="element-127" data-mp="3ggyme2mjt7s7" />
              <p className="inline-flex items-center gap-2 font-sans text-xs text-brand-ink/50" data-id="element-128" data-mp="2js93c8z6q94n">
                <QuoteIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-129" data-mp="2oq0wt7fha3ay" />
                Atención confidencial, sin compromiso.
              </p>
            </div>
          </Reveal>
        </div>
      </div>
    </section>;
}